import RightHeader from './RightHeaderContainer';

export default RightHeader;